import Vue from 'vue' 
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'

import { interpolate } from 'polymorph-js'

/*

function svgMorph(left, right) {
  // configure polymorph here
  return polymorph.interpolate([left, right], { 
     precision: 2,
   
     origin: {
        x: 5,
        y: 5,
        absolute: true
     }
  })
}

const t1 = just.animate({
  targets: '#target',
  duration: 7000,
  props: {
     d: {
        interpolate: svgMorph,
        easing: 'cubic-bezier(.5,0,.5,1)',
        value: [
           '#bubble1 path', 
           '#bubble2 path'
        ]
     }
  }
})
t1.play();*/





import Home from './../vue/Home'
/* Example class */
//import ExampleClass from './example.js'
//const exampleClass = new ExampleClass()
//exampleClass.helloWorld()

/* Vue instance 
new Vue({
  el: '#app',
  render: h => h(Home)
})*/ 

$("document").ready(function() {

  $(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
        $('.mainNavigation').addClass('scrolling');
        $('.mobileMenu').addClass('scrolling');
    } else {
        $('.mainNavigation').removeClass('scrolling');
        $('.mobileMenu').removeClass('scrolling');
    }
    
    if ($(window).scrollTop() > 700) {
      $('.scroller').addClass('active');
    } else {
      $('.scroller').removeClass('active');
    }
});

  $(window).resize(function() {
    if($(window).width()>850) {
      $('.mobileMenu').hide();
      $('.hamburger').removeClass('is-active');
    }

  });
  if($(window).width()<=850) {
    $('.closeBtn').bind('click',function() { 

      $('.search-section').hide();
    return false;
    });
    $('.mobileMenu .menu-item-has-children > a').bind('click',function() { 

      $(this).parent().toggleClass('active');
      $(this).parent().find('.sub-menu').slideToggle();
    return false;
    });
  }



  $('.scroller').click(function() { 
    $("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
  });

  

  var didScroll = false;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('#menu').outerHeight();
  
  

  $(window).scroll(function(){
      didScroll = true;
      
  });
  
  setInterval(function() {
      if (didScroll) {
          hasScrolled();
          didScroll = false;
      }
  }, 250);
  
  function hasScrolled() {
      var st = $(window).scrollTop();
      
      
      if(Math.abs(lastScrollTop - st) <= delta)
          return;
     
      if (st > lastScrollTop && st > navbarHeight){
          // Scroll Down
          
          $('.mainNavigation').removeClass('nav-down').addClass('nav-up');
          $('.mobileMenu').hide();
          $('.hamburger').removeClass('is-active');
      } else {
          // Scroll Up
         
          if(st + $(window).height() < $(document).height()) {
              $('.mainNavigation').removeClass('nav-up').addClass('nav-down');
              $('.mobileMenu').hide();
              $('.hamburger').removeClass('is-active');
          }
      }
      
      lastScrollTop = st;
  }


  if ($('.hamburger').length > 0) {
    $('.hamburger').bind('click',function() { 
      
      $(this).toggleClass('is-active');
      $('.mobileMenu').slideToggle();
    
      return false;
    });

    $('.mobileMenu.menu-item-has-children > a').click(function() { 
     
        $(this).parent().find('.sub-menu').slideToggle();
        $(this).toggleClass('active');
        return false;
   

    });

    $('.search-icon').click(function() { 
      $('.search-section').slideToggle();
      
      return false;
    });

    
  }


	if($('#mainAccordion').length > 0){

		$(".accordionHeader").click(function() { 
            $(this).parent().toggleClass("active");
            $(this).parent().children('.accordionContent').slideToggle();
            return false;
		});
		

  }



  if ($('.gallery').length > 0) {
 
    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
  }
  if ($('.flexslider').length > 0) {
    $('.flexslider').flexslider({
      animation: "fade",
      direction: "vertical",
      directionNav: false,
      animationLoop: true,
      controlNav: true,
      pauseOnHover: false,
      prevText: "",
      nextText: ""
  });
  }


  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top-100
        }, 1000);
        return false;
    }
    }
});

});